import { GamgeeChatMessageRead } from '~/types/message';
import UpdateWindow from './update-window';

interface UpdateSectionProps {
  updateIdsInOrder: string[];
  updateTracker: { current: any };
  message: GamgeeChatMessageRead;
}

const UpdateSection = ({ updateIdsInOrder, updateTracker, message }: UpdateSectionProps) => {
  return (
    <div className="flex flex-col gap-2">
      {updateIdsInOrder.map((id) => {
        const update = updateTracker.current[id];
        const isShimmering = !update.is_final;

        return (
          <UpdateWindow
            key={id}
            title={update.title}
            content={update.content}
            isStreaming={isShimmering}
            message={message}
          />
        );
      })}
    </div>
  );
};

export default UpdateSection;
